const doc = [({"en":({"js":({"navigations":({"show":({"navigation":"Navigation"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;